import { filterDTO, unformattedFilterDTO } from "../types";

const FilterTypeUi: { [key: string]: "datepicker" | "textbox" | "boolean" | "MultiSelectBox" } = {
    "Date": "datepicker",
    "String": "textbox",
    "Integer": "textbox",
    "IntegerTime": "textbox",
    "Boolean": "boolean",
    "MultiSelectBox": "MultiSelectBox"
}
  
const ComparisonAndLogicalTSQLOperators: { [key: number]: string } = {
    0: "Unknown",
    1: "Equal to",
    2: "Greater than",
    3: "Less than",
    4: "Greater than or equal to",
    5: "Less than or equal to",
    6: "Not equal to",
    7: "Not equal to (Not ISO Standard)",
    8: "Not less to (Not ISO Standard)",
    9: "Not greater to (Not ISO Standard)",
    10: "Between",
    11: "Not Between",
    12: "In",
    13: "Not In",
    14: "Like",
    15: "Not Like"
}

//Disables some comparison and logical operators from front-end
const disableOperators: number[] = [
    6,  //  "Not equal to"
    11, //  "Not Between"
    13, //  "Not In"
    15  //  "Not Like"
]
    

const isOperatorEnabled = (key: number): boolean => {
    return disableOperators.includes(key) ?  false : true;
}

function addFilterTypeUI(filter: filterDTO): filterDTO {
    if(ComparisonAndLogicalTSQLOperators[filter.operatorID] == "In"){
        filter.typeUI = FilterTypeUi["MultiSelectBox"];
    }
    else{
        filter.typeUI = FilterTypeUi[filter.columnDataType];
    }
    return filter;
}

const addBooleanData = (filter: filterDTO): filterDTO => {
    if (filter.typeUI == "boolean") {
        filter.filterSelectValues = [
            {id: 1, value: "True"},
            {id: 0, value: "False"},
        ];
    }
    return filter;
}

const transformValidOperators = (filter: filterDTO): filterDTO => {
    filter.transformedValidOperators = [];

    filter.validOperatorIDs.map((id: number) => {
        if(isOperatorEnabled(id)){
            filter.transformedValidOperators = [
                ...filter.transformedValidOperators, 
                ...[{
                    id: id,
                    value: ComparisonAndLogicalTSQLOperators[id]
                }]
            ]
        }
    
    })
    return filter;
}

export const DefaultFilterMapToFitlerDTO = (unformattedFilters: unformattedFilterDTO[]): filterDTO[] => {
    let filterArray: filterDTO[] = [];
    try{
        if(!unformattedFilters) return filterArray;
        
        unformattedFilters.map((filter: unformattedFilterDTO) => {
            if (filter) {
                filter = addFilterTypeUI(filter as filterDTO);
                filter = addBooleanData(filter as filterDTO)
                filter = transformValidOperators(filter as filterDTO);
                filter.filterSelectValues = filter.filterSelectValues == undefined ? filter.values : filter.filterSelectValues;

                filterArray = [...filterArray, filter as filterDTO]
            }
        });  
    } 
    catch (error) {
        console.error(error);
    }
    return filterArray;
}